import { environment } from '../../../environments/environment';

/**
 * Who sees the executive-only extras (Reports, Assistant Insights, App Logs,
 * the support desk's connection panel). In the demo build that is anyone
 * holding ROLE_ADMIN, which is the CEO persona.
 */
export function isDemoExec(user: { roles?: string[] | null } | null | undefined): boolean {
    return !!(environment as { demo?: boolean }).demo && !!user?.roles?.includes('ROLE_ADMIN');
}
